"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("../../../node_modules/graphql-tag/lib/index.js").gql`
    mutation deleteCollectionModel($collectionModelId: Int!) {
        deleteCollectionModel(
            input: { corpCollectionModelId: $collectionModelId }
        ) {
            collectionModel {
                corpCollectionId
                corpCollectionModelId
                modelNumber
            }
        }
    }
`;exports.removeCollectionModel=e;
//# sourceMappingURL=queries.js.map
